import { TwoColumnLayout } from 'layouts';
import type { InvitationToken, PublicEventContentObject } from 'models';
import { EventDetailCountdown } from '../../components';
import { PublicProgramEventHeader } from '../../public-program-event-header';
import { SharedProgramEventEnter } from './shared-program-event-enter';

type P = {
  eventContentObject: PublicEventContentObject;
  invitationToken: InvitationToken;
};

const SharedProgramEventContent = ({ eventContentObject, invitationToken }: P) => (
  <>
    <PublicProgramEventHeader eventContentObject={eventContentObject} />
    <TwoColumnLayout
      left={<SharedProgramEventEnter eventContentObject={eventContentObject} invitationToken={invitationToken} />}
      right={<EventDetailCountdown startTime={eventContentObject.event.startTime} />}
    />
  </>
);

export default SharedProgramEventContent;
